module.exports = __webpack_public_path__ + "img/youtube.901eac56.svg";